import React from 'react'

const Loader = () => {
  return (
    <div class="loader_holder">
        <div className="loader"></div>
    </div>
  )
}

export default Loader